import type { HTMLAttributes } from 'react'

import { classNames } from '@/utils/helpers.ts'

export const Skeleton = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={classNames(
        'bg-muted bg-skeleton animate-pulse rounded-md',
        className,
      )}
      {...props}
    />
  )
}
